export const sortKeysByField = <K extends string, F extends string>(
  record: Record<K, Record<F, string>>,
  field: F
): K[] => (Object.keys(record) as K[]).sort((a, b) => record[a][field].localeCompare(record[b][field]));
